module.exports = __webpack_public_path__ + "static/Oluchi__Oladokun-4868ae6ab0c660185d417f420a549623.png";